import type { Theme } from "@/components/admin/theme-context";
import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/vv-dark.svg";
import lightModeLogo from "./logos/vv-light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "RUB";

// Theme «Графит» (dark, see index.css) until the user picks another one with
// the theme toggle: the look the pilot staff know from their dashboard.
export const defaultThemeMode: Theme = "dark";

export const defaultTitle = "Всё видно";

// the company's day (overdue tasks, notice hours); the owner changes it in Settings
export const defaultTimezone = "Europe/Moscow";

export const defaultCompanySectors = [
  { value: "manufacturing", label: "Производство" },
  { value: "trade", label: "Торговля" },
  { value: "construction", label: "Стройка" },
  { value: "services", label: "Услуги" },
  { value: "logistics", label: "Логистика" },
  { value: "other", label: "Другое" },
];

// "won" and "lost" are fixed values: the pipeline, the chart and the
// server rely on them. Only the labels are Russian.
export const defaultDealStages = [
  { value: "new", label: "Новая" },
  { value: "qualification", label: "Квалификация" },
  { value: "proposal-sent", label: "КП отправлено" },
  { value: "negotiation", label: "Переговоры" },
  { value: "invoiced", label: "Счёт выставлен" },
  { value: "paid", label: "Оплачено" },
  { value: "won", label: "Отгружено" },
  { value: "lost", label: "Проиграна" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "goods", label: "Товары" },
  { value: "services", label: "Услуги" },
  { value: "project", label: "Проект" },
  { value: "other", label: "Другое" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Холодный", color: "#7dbde8" },
  { value: "warm", label: "Тёплый", color: "#e8cb7d" },
  { value: "hot", label: "Горячий", color: "#e88b7d" },
  { value: "in-contract", label: "В договоре", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "call", label: "Звонок" },
  { value: "meeting", label: "Встреча" },
  { value: "email", label: "Письмо" },
  { value: "proposal", label: "КП" },
  { value: "other", label: "Другое" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
  timezone: defaultTimezone,
};
